import { useState, useCallback } from 'react';
import './App.css';

function App() {
  const [noClickCount, setNoClickCount] = useState(0);
  const [showSuccess, setShowSuccess] = useState(false);
  const [noButtonStyle, setNoButtonStyle] = useState({});
  const [heartSpeed, setHeartSpeed] = useState(1);

  const handleYesClick = () => {
    setShowSuccess(true);
    const audio = new Audio('/hudba.mp3');
    audio.play().catch(e => console.log("Audio play failed:", e));
  };

  const handleNoClick = useCallback(() => {
    const newCount = noClickCount + 1;
    setNoClickCount(newCount);

    // Move the button to a random position
    const maxX = window.innerWidth - 150;
    const maxY = window.innerHeight - 100;
    const randomX = Math.random() * maxX;
    const randomY = Math.random() * maxY;

    setNoButtonStyle({
      position: 'fixed',
      left: `${randomX}px`,
      top: `${randomY}px`,
    });

    // Speed up the heartbeat
    setHeartSpeed(prev => Math.max(0.2, prev - 0.1));
  }, [noClickCount]);

  // Generate confetti elements
  const renderConfetti = () => {
    const confetti = [];
    const colors = ['#ff6b9d', '#c06c84', '#ffd700', '#ff1493', '#ff69b4'];

    for (let i = 0; i < 50; i++) {
      confetti.push(
        <div
          key={i}
          className="confetti"
          style={{
            left: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 3}s`,
            backgroundColor: colors[Math.floor(Math.random() * colors.length)],
          }}
        />
      );
    }
    return confetti;
  };

  // Get the appropriate emoji and text based on click count
  const getNoButtonContent = () => {
    if (noClickCount >= 8) return null; // Button disappears
    if (noClickCount >= 5) return '😤 NE!';
    return 'Ne';
  };

  if (showSuccess) {
    return (
      <div className="app">
        <div className="celebration">{renderConfetti()}</div>
        <div className="container success-container">
          <div className="emoji">🎉</div>
          <h1 className="title">JUPÍÍÍÍÍ! 💕</h1>
          <p className="question">Jupíííí, jsi moje životní láska, děkuju, že tě mám. Miluju tě hrozně moc!</p>
          
          <div className="photo-container">
            <img src="/foto.jpg" alt="My love" className="love-photo" />
          </div>

          <div className="floating-hearts">
            {[...Array(10)].map((_, i) => (
              <span key={i} className="floating-heart" style={{
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 2}s`
              }}>❤️</span>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="app">
      <div className="container">
        <h1 className="title">Ahoj, Týnko! 💕</h1>

        <div
          className="heart"
          style={{ animationDuration: `${heartSpeed}s` }}
        >
          ❤️
        </div>

        <p className="question">Budeš moje valentýnka?</p>

        <div className="buttons">
          <button className="yes-btn" onClick={handleYesClick}>
            Ano! 💖
          </button>

          {noClickCount < 8 && (
            <button
              className="no-btn"
              onClick={handleNoClick}
              style={noButtonStyle}
            >
              {getNoButtonContent()}
            </button>
          )}
        </div>

        {noClickCount >= 5 && (
          <div
            className="angry-emoji"
            style={{ fontSize: noClickCount >= 8 ? '6em' : '4em' }}
          >
            😠
          </div>
        )}

        {noClickCount >= 3 && noClickCount < 5 && (
          <p className="hint">Přestaň tohle mačkat, lásko, já tě chci moc :(</p>
        )}

        {noClickCount >= 8 && (
          <p className="hint final-hint">No tak klikni na Ano! 💕</p>
        )}
      </div>
    </div>
  );
}

export default App;